import {
    createSlice
} from "@reduxjs/toolkit";
import {
    createAd,
    getAdAnalytics,
    getAdPlan,
    getAllAds,
    getLiveAds,
    updateAd
} from "./thunk";
export const initialState = {
    data:[],
    ads:[],
    adPlans: [],
    error: "", // for error message
    loading: false,
};

const adsSlice = createSlice({
    name: "ads",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getLiveAds.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getLiveAds.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getLiveAds.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            })
            .addCase(getAllAds.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAds.fulfilled, (state, action) => {
                state.ads = action.payload;
                state.loading = false;
            })
            .addCase(getAllAds.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : null;
                state.loading = false;
            })
            .addCase(getAdPlan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdPlan.fulfilled, (state, action) => {
                state.adPlans = action.payload;
                state.loading = false;
            })
            .addCase(getAdPlan.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            })
            .addCase(createAd.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAd.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(createAd.rejected, (state, action) => {
                state.error = action.payload.error || null;
                state.loading = false;
            })
            .addCase(updateAd.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAd.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(updateAd.rejected, (state, action) => {
                state.error = action.payload.error || null;
                state.loading = false;
            })
    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default adsSlice.reducer;